import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { apiErrorMessage } from '../pages/tax/taxWorkspace';
import MembershipRequestDialog from './MembershipRequestDialog';
import './MembershipSwitcher.css';

export default function MembershipSwitcher({ compact = false }) {
  const { tenant, memberships, selectMembership, refreshMemberships } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [requestOpen, setRequestOpen] = useState(false);
  const availableMemberships = memberships || [];

  if (availableMemberships.length <= 1) {
    return null;
  }

  const change = async event => {
    const slug = event.target.value;
    if (!slug || slug === tenant?.slug) return;
    setBusy(true); setError('');
    try {
      const selected = await selectMembership(slug);
      const portal = selected.membership?.portal_type;
      navigate(portal === 'admin' ? `/admin/${slug}/dashboard` : `/gp/${slug}/my-taxes`);
    } catch (err) { setError(apiErrorMessage(err)); } finally { setBusy(false); }
  };

  return <div className={`membership-switcher ${compact ? 'compact' : ''}`}>
    {availableMemberships.length > 1 && <label><span>Active GP / ग्रामपंचायत</span><select aria-label="Active Gram Panchayat" value={tenant?.slug || ''} onChange={change} disabled={busy}>{availableMemberships.map(item => <option key={item.membership_uid} value={item.tenant?.slug} disabled={item.status !== 'active'}>{item.tenant?.name || item.tenant?.slug}{item.status !== 'active' ? ` (${item.status})` : ''}</option>)}</select></label>}
    <button type="button" className="membership-request-trigger" onClick={() => { setRequestOpen(true); setError(''); }} title="दुसऱ्या ग्रामपंचायतीतील नोंदणीकृत व्यवसायासाठी प्रवेश मागा">
      <span className="membership-request-full">+ दुसऱ्या GP मधील प्रवेश</span>
      <span className="membership-request-short" aria-hidden="true">+ GP</span>
    </button>
    {error && <small role="alert">{error}</small>}
    {requestOpen && <MembershipRequestDialog onClose={() => setRequestOpen(false)} onMembershipsChanged={refreshMemberships} />}
  </div>;
}
